export default __webpack_public_path__ + "787cd05290fa84649717771c9e56e98c.svg";